import { RowSize, RowSizes } from "~/components/DataGrid";
import { Networks } from "~/schema";
import { Emdash } from "~/components/Punctuation";
import { Anchor } from "~/components/Anchor";
import { cn } from "~/lib/utils";
import { Tooltip } from "~/components/Tooltip";
import { truncateMiddleOfString } from "~/utils/functions/truncateMiddleOfString";
import {
    getBlockchainExplorerUrl,
    EXPLORER_NAMES,
} from "./getBlockchainExplorerUrl";
import { CopyAddressButton } from "./CopyAddressButton";

// // // //

export function BlockchainExplorerLink(props: {
    address: null | string;
    networkSlug: string;
    analyticsLabel: string;
    label?: string;
    size: RowSize;
    type: "address" | "tx" | "token";
    truncate?: boolean;
}) {
    const { address, networkSlug, analyticsLabel, size, type } = props;
    const truncate = props.truncate ?? true;
    const label = props.label || address;

    if (label === null) {
        return <Emdash />;
    }

    const displayLabel = truncate ? truncateMiddleOfString(label) : label;

    const href = getBlockchainExplorerUrl({ networkSlug, address, type });

    // If there's no block explorer URL, just show the address + copy button
    if (!href) {
        return (
            <div className="font-mono inline-flex items-center text-secondary-foreground">
                <Tooltip
                    placement="top"
                    tooltipContent={
                        <div className="w-max px-2 py-1">
                            <p className="whitespace-nowrap text-xs font-mono">
                                {address}
                            </p>
                        </div>
                    }
                >
                    {({ setTriggerRef }) => (
                        <span
                            ref={setTriggerRef}
                            className="inline-flex items-center cursor-default"
                        >
                            {displayLabel}
                        </span>
                    )}
                </Tooltip>
                <CopyAddressButton address={address as string} />
            </div>
        );
    }

    return (
        <div className="flex items-center">
            <Anchor
                openInNewTab
                href={href}
                analyticsLabel={analyticsLabel}
                variant="default"
                className={cn(
                    "font-mono inline-flex items-center",

                    {
                        "text-xs": size === RowSizes.extraSmall,
                        "text-sm": size === RowSizes.small,
                        "text-base": size === RowSizes.medium,
                        "text-lg": size === RowSizes.large,
                        "text-xl": size === RowSizes.extraLarge,
                    },
                )}
            >
                <Tooltip
                    placement="top"
                    tooltipContent={
                        <div className="w-max px-2 py-1">
                            <p className="whitespace-nowrap text-xs font-mono">
                                {address}
                            </p>
                            <p className="whitespace-nowrap text-xs mt-1 text-center">
                                Click to view on{" "}
                                {EXPLORER_NAMES[networkSlug as Networks]}
                            </p>
                        </div>
                    }
                >
                    {({ setTriggerRef }) => (
                        <span
                            ref={setTriggerRef}
                            className="inline-flex items-center"
                        >
                            {displayLabel}
                        </span>
                    )}
                </Tooltip>
            </Anchor>
            <CopyAddressButton address={address as string} />
        </div>
    );
}
